import React from 'react';
import { Settings, ChevronDown } from 'lucide-react';

export interface ModeStyle02Props {
  value?: string;
  options: string[];
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: string) => void;
  label?: string;
  modeLabels?: Record<string, string>;
}

// Default mode translations
const DEFAULT_MODE_LABELS: Record<string, string> = {
  '1': '節能',
  '3': '標準',
  '5': '強力',
  '8': '連續',
  'auto': '自動',
  'cool': '製冷',
  'heat': '制暖',
  'dry': '除濕',
  'fan': '送風'
};

/**
 * Mode Style 02 - Dropdown Select
 * Command: SetModes
 * Dropdown selector for modes (compact layout)
 */
export const Style02_Dropdown: React.FC<ModeStyle02Props> = ({
  value,
  options,
  disabled = false,
  loading = false,
  onChange,
  label = '運轉模式',
  modeLabels
}) => {
  const getModeLabel = (mode: string): string => {
    return modeLabels?.[mode] || DEFAULT_MODE_LABELS[mode] || mode;
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Settings className="w-4 h-4 text-indigo-400" />
        <span className="text-sm font-medium text-slate-300">{label}</span>
      </div>
      <div className="relative">
        <select
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled || loading}
          className="w-full px-4 py-3 pr-10 rounded-xl bg-slate-700/50 text-white text-sm font-medium appearance-none cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed border border-slate-600/50 focus:border-indigo-500 focus:outline-none transition-colors"
        >
          {options.map((mode) => (
            <option key={mode} value={mode}>
              {getModeLabel(mode)}
            </option>
          ))}
        </select>
        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" />
      </div>
    </div>
  );
};

export default Style02_Dropdown;
